module.exports = __webpack_public_path__ + "img/sunset_color.76713128.svg";